/**
 * @module @semaphore-protocol/utils
 * @version 4.5.0
 * @file A library to provide utility functions to the other Semaphore packages.
 * @copyright Ethereum Foundation 2024
 * @license MIT
 * @see [Github]{@link https://github.com/semaphore-protocol/semaphore/tree/main/packages/utils}
*/
import _interface from './semaphore-interface.json.js';

// Minimum supported tree depth.
const MIN_DEPTH = 1;
// Maximum supported tree depth.
const MAX_DEPTH = 32;
const SemaphoreABI = _interface.abi;
const SemaphoreBytecode = _interface.bytecode;

export { MAX_DEPTH, MIN_DEPTH, SemaphoreABI, SemaphoreBytecode };
